import { useEffect, useState } from "react";

/**
 * The single breakpoint that decides which presentation renders. Below it the
 * Konsta (Android-style) tree is mounted, at or above it the shadcn dashboard.
 */
export const HANDHELD_QUERY = "(max-width: 1023.98px)";

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const list = window.matchMedia(query);
    const update = () => setMatches(list.matches);
    update();
    list.addEventListener("change", update);
    return () => list.removeEventListener("change", update);
  }, [query]);

  return matches;
}

export function useHandheld(): boolean {
  return useMediaQuery(HANDHELD_QUERY);
}
